import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyConnectProjectRoute: InvariantJiraRoute = {
	name: 'legacy-connect-project',
	path: '/projects/:projectKey',
	query: ['selectedItem'],
};
